import React, { useEffect, useRef } from "react"
import { toast } from "react-toastify"
import CabCard from "../../../components/Cards/CabCard"
import { cabAction } from "../../../store/Cab/CAbReducer"
import { useSelector, useDispatch } from "react-redux"
import Loading from "../../../components/Loading"

const CabBox = ({ tripDetails }) => {
  const dispatch = useDispatch()
  const { loading, cabs, error } = useSelector((state) => state.cab)
  const lastToastErrorRef = useRef(null)

  const isRateLimitError =
    error &&
    typeof error === "string" &&
    (error.includes("Rate limit") || error.includes("Maximum"))

  const isDateMissingError =
    error === "Please select return date and time to see cabs."

  useEffect(() => {
    if (error && lastToastErrorRef.current !== error && !isDateMissingError) {
      lastToastErrorRef.current = error
      toast.error(
        isRateLimitError
          ? "You've exceeded the request limit. Please try again after a few hours."
          : error
      )
    }

    if (!error) lastToastErrorRef.current = null
  }, [error, isRateLimitError, isDateMissingError])

  useEffect(() => {
    const loadStoredCabResult = () => {
      const stored = localStorage.getItem("cabSearchResult")

      if (!stored) return

      try {
        const parsed = JSON.parse(stored)

        // Only set result when API response has cab data.
        // This prevents route-page loading from staying stuck after Modify/Search.
        if (parsed && Array.isArray(parsed.data)) {
          dispatch(cabAction.setCabSearchResult(parsed))
        }
      } catch {
        localStorage.removeItem("cabSearchResult")
      }
    }

    loadStoredCabResult()

    // UpdateOutstationForm dispatches this event after Modify/Search.
    // Same route component does not always remount, so CabBox must listen manually.
    window.addEventListener("tripDataUpdated", loadStoredCabResult)
    window.addEventListener("storage", loadStoredCabResult)

    return () => {
      window.removeEventListener("tripDataUpdated", loadStoredCabResult)
      window.removeEventListener("storage", loadStoredCabResult)
    }
  }, [dispatch, tripDetails])

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <div className="cabCardBox">
          {cabs?.length > 0 ? (
            <div className="cabCardBox__list">
              {[...cabs]
                .sort((a, b) => (a.vehicle_id || 0) - (b.vehicle_id || 0))
                .map((cab) => (
                  <CabCard
                    key={cab?.id || cab?.vehicle_id}
                    showPrice={true}
                    cab={cab}
                  />
                ))}
            </div>
          ) : isRateLimitError ? (
            <div className="cabCardBox__limitMsg">
              You've exceeded the request limit. Please try again after a few hours.
            </div>
          ) : isDateMissingError ? (
            <div
              className="cabCardBox__limitMsg"
              style={{
                textAlign: "center",
                padding: "20px",
                color: "red",
                fontWeight: "bold",
              }}
            >
              {error}
            </div>
          ) : (
            <div>No cabs available.</div>
          )}
        </div>
      )}
    </>
  )
}

export default CabBox